import React from 'react';
import { ValidationError } from '@atlassian/jira-fetch';
import { FlagRenderer } from '@atlassian/jira-flags';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl';

type Props = {
	error: Error | ValidationError;
	title: MessageDescriptor;
	description: MessageDescriptor;
};

export const ErrorFlag = ({ error, title, description }: Props) => {
	if (!error) {
		return null;
	}
	if (error instanceof ValidationError) {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const errorMessage: any =
			error.message || (error.errors && error.errors[0] && error.errors[0].error) || description;

		return (
			<FlagRenderer
				// @ts-expect-error - TS2322 - Type '{ flag: { type: string; title: MessageDescriptorV2; description: any; }; }' is not assignable to type 'IntrinsicAttributes'.
				flag={{
					type: 'warning',
					title,
					description: errorMessage,
				}}
			/>
		);
	}
	return (
		<FlagRenderer
			// @ts-expect-error - TS2322 - Type '{ flag: { type: string; title: MessageDescriptorV2; description: MessageDescriptorV2; }; }' is not assignable to type 'IntrinsicAttributes'.
			flag={{
				type: 'error',
				title,
				description,
			}}
		/>
	);
};
